import { createTheme } from '@mui/material/styles'
import { orange } from '@mui/material/colors'

const theme = createTheme({
  components: {
    Card: {
      background: 'red'
    }
  },
  status: {
    danger: orange[500]
  },
  palette: {
    primary: {
      main: '#185273',
      contrastText: 'white'
    },
    secondary: {
      main: '#185273',
      bg: '#fff'
    },
    neutral: {
      main: '#0000FF'
    },
    background: {
      main: '#F5F5F5'
    },
    default: {
      main: '#808080'
    },
    orange: {
      main: '#E55E11'
    },
    leitura: {
      main: '#185273',
      contrastText: 'white'
    },
    green: {
      main: '#1b7001'
    },
    redstrong: {
      main: '#70011c'
    },
    white: {
      main: '#FFFFFF'
    }
  }
})

export default theme
